import React, { useEffect } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { Box, Button, Flex, Text } from 'rebass';
import FullLayout2 from '../asyncIntake/screens/components/FullLayout';
import Div100vh, { measureHeight } from 'react-div-100vh';
import styled, { keyframes } from 'styled-components';
import { TEXT_ANIMATION_DURATION } from '../weightLossPrequalification/components/constants';
import { useState } from 'react';
import PleaseWait from '../../components/PleaseWait';
import { withRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { LogoSvg } from '../weightLossPrequalification/components/Logo';
import queryString from 'query-string';

const slideLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateY(15px);
  };
  100% {
    opacity: 1;
    transform: translateY(0px);
  };
`;
const Container = styled(Div100vh)`
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow-y: ${(props) => (isMobile ? 'hidden' : '')};
  display: flex;
  flex-direction: column;
`;

const Description = styled(Text)`
  opacity: 0;
  animation: 400ms cubic-bezier(0.64, 0, 0.28, 1) 0s 1 normal forwards running ${slideLeft};
`;
const CHECK_WEIGHTLOSS_MEMBER = gql`
  query getIsSubscribedToWeightlossMembership {
    getIsSubscribedToWeightlossMembership {
      ok
    }
  }
`;

const Inner = ({ loading, data, refetch, history }) => {
  const [attempts, setAttempts] = useState(0);
  const vh100 = `${measureHeight()}px` || '100vh';
  const descriptionPre = `We are waiting for confirmation of your enrollment.`;
  useEffect(() => {
    const intervalId = setInterval(() => {
      // console.log({loading})
      // if (!!loading) return;

      setAttempts((attempts) => attempts + 1);
      refetch();

      return () => {
        clearInterval(intervalId);
      };
    }, 10000); // Update every 1 second

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);
  console.log({ attempts });
  return (
    <FullLayout2 style={{ zIndex: 11, overflowY: isMobile ? 'hidden' : 'auto', maxHeight: vh100 }} pb={5}>
      <Container flexDirection={'column'} flex={1}>
        <Box mb={4} />
        <LogoSvg />
        <Flex flexWrap={'wrap'} mt={4} mb={5}>
          {descriptionPre.split(' ').map((x, i) => {
            return (
              <Description key={`descriptionPre_${x}_i`} style={{ fontSize: isMobile?'26px':'32px', fontWeight: 500, animationDelay: `${i * TEXT_ANIMATION_DURATION}s` }}>
                {x}
                &nbsp;
              </Description>
            );
          })}
        </Flex>
        <PleaseWait />
        {attempts > 5 && (
          <>
            <Text style={{ fontSize: '13px', fontWeight: 400, maxWidth: '600px' }} mt={5} textAlign={'center'}>
              This is taking longer than anticipated. You can return to your dashboard, and you'll receive an email confirmation soon. Once your Weight Loss membership is confirmed, you'll be able to
              schedule a weight loss visit.
            </Text>

            <Button mt={4} variant={'primary'} onClick={() => history.push('/')} style={{ alignSelf: 'center' }}>
              Go Back to Dashboard
            </Button>
          </>
        )}
      </Container>
    </FullLayout2>
  );
};

const PendingWeightLossRegistrationIn = ({ history, location }) => {
  const queryParams = queryString.parse(location.search);

  return (
    <Query
      query={CHECK_WEIGHTLOSS_MEMBER}
      onCompleted={(e) => {
        if (e && e.getIsSubscribedToWeightlossMembership && e.getIsSubscribedToWeightlossMembership.ok) {
          if (!!queryParams && queryParams.redirect) {
            const goto = decodeURIComponent(queryParams.redirect);
            history.push(goto);
            return;
          }
          history.push('/');
        }
      }}
    >
      {({ loading, data, refetch }) => {
        return <Inner loading={loading} data={data} refetch={refetch} history={history} />;
      }}
    </Query>
  );
};

export const PendingWeightLossRegistration = withRouter(PendingWeightLossRegistrationIn);
